'use strict';

var BB = window.BB || {
  routes: {
    cart_add:    '/cart/add.js',
    cart:        '/cart.js',
    cart_change: '/cart/change.js',
    cart_update: '/cart/update.js',
  },
  cartCount: 0,
  moneyFormat: 'EGP {{amount}}',
  shopCurrency: 'EGP',
};

/*
  Single source of truth for money display on the storefront: Arabic-Indic
  digits, currency after the number ("٥٣٥ EGP"), trailing ".00" stripped for
  whole amounts. Mirrors snippets/arabic-price.liquid exactly so a
  Liquid-rendered price and a JS-updated one (variant change, cart drawer,
  etc.) are always visually identical — never format money any other way.
*/
var ARABIC_DIGITS = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
function toArabicDigits(str) {
  return String(str).replace(/[0-9]/g, function (d) { return ARABIC_DIGITS[+d]; });
}
function formatArabicMoney(cents) {
  var amount = cents / 100;
  var numStr = (cents % 100 === 0) ? String(Math.round(amount)) : amount.toFixed(2);
  return toArabicDigits(numStr) + ' EGP';
}
/* A price string that might already be in the new "٥٣٥ EGP" format (saved
   after this fix) or the old raw-number format (saved to a wishlist before
   it) — displays either consistently without needing to migrate storage. */
function displayStoredPrice(raw) {
  var str = String(raw || '0');
  if (str.indexOf('EGP') !== -1) return str;
  return toArabicDigits(str) + ' EGP';
}

function toast(msg) {
  var el = document.getElementById('toast');
  if (!el) return;
  el.textContent = msg;
  el.classList.add('show');
  clearTimeout(el._timer);
  el._timer = setTimeout(function () { el.classList.remove('show'); }, 2800);
}

function escHtml(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

var hamburger     = document.getElementById('hamburger');
var mobileMenu    = document.getElementById('mobileMenu');
var mobileClose   = document.getElementById('mobileClose');
var overlay       = document.getElementById('overlay');
var cartBtn       = document.getElementById('cartBtn');
var cartDrawer    = document.getElementById('cartDrawer');
var cartClose     = document.getElementById('cartClose');
var cartShopLink  = document.getElementById('cartShopLink');
var cartCount     = document.getElementById('cartCount');
var cartItems     = document.getElementById('cartItems');
var cartEmpty     = document.getElementById('cartEmpty');
var cartFooter    = document.getElementById('cartFooter');
var cartTotal     = document.getElementById('cartTotal');

/* ── Cart API ── */
var CartAPI = {
  get: function () {
    return fetch(BB.routes.cart, {
      headers: { 'Content-Type': 'application/json' }
    }).then(function (r) { return r.json(); });
  },

  add: function (variantId, qty, properties) {
    var lineItem = { id: parseInt(variantId, 10), quantity: qty || 1 };
    if (properties) lineItem.properties = properties;
    return fetch(BB.routes.cart_add, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [lineItem] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (d) {
        throw new Error(d.description || d.message || 'حدث خطأ');
      });
      return r.json().then(function (d) { return d.items ? d.items[0] : d; });
    });
  },

  /* Takes the cart's stable line-item key (a string), never the line's
     numeric position -- a position goes stale the instant another line
     is removed/reordered. Mirrors the cart PAGE's changeByKey, which
     already used the correct approach; the drawer previously used
     idx+1 (the array position at last render time), baked directly
     into an inline onclick, which could point at the wrong line or a
     position that no longer exists after any other change. */
  changeLine: function (key, qty) {
    return fetch(BB.routes.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  },

  update: function (updates) {
    return fetch(BB.routes.cart_update, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) { return r.json(); });
  }
};

/* ── Cart Count ── */
function updateCartCount(count) {
  BB.cartCount = count;
  if (!cartCount) return;
  cartCount.textContent = count;
  if (count > 0) {
    cartCount.classList.remove('hidden');
  } else {
    cartCount.classList.add('hidden');
  }
  var btn = document.getElementById('cartBtn');
  if (btn) btn.setAttribute('aria-label', 'فتح السلة، ' + count + ' منتج');
}

/* ── Cart Drawer Render ── */
function renderCartDrawer(cart) {
  if (!cartItems || !cartEmpty || !cartFooter) return;

  var hasItems = cart.item_count > 0;
  cartEmpty.style.display = hasItems ? 'none' : '';
  if (hasItems) {
    cartFooter.classList.add('visible');
  } else {
    cartFooter.classList.remove('visible');
  }

  if (!hasItems) { cartItems.innerHTML = ''; return; }

  cartItems.innerHTML = cart.items.map(function (item) {
    var imgHtml = item.image
      ? '<img src="' + item.image + '" alt="' + escHtml(item.product_title) + '" width="80" loading="lazy">'
      : '';

    var variantHtml = item.variant_title && item.variant_title !== 'Default Title'
      ? '<p class="cart-item__variant">' + escHtml(item.variant_title) + '</p>'
      : '';

    var keyArg = JSON.stringify(item.key);

    return '<li class="cart-item">' +
      '<div class="cart-item__img">' + imgHtml + '</div>' +
      '<div>' +
        '<p class="cart-item__name">' + escHtml(item.product_title) + '</p>' +
        variantHtml +
        '<p class="cart-item__price">' + formatArabicMoney(item.price) + '</p>' +
        '<div class="cart-item__qty">' +
          '<button type="button" onclick="cartDrawerQty(' + keyArg + ',' + (item.quantity - 1) + ')" aria-label="تقليل">−</button>' +
          '<span>' + item.quantity + '</span>' +
          '<button type="button" onclick="cartDrawerQty(' + keyArg + ',' + (item.quantity + 1) + ')" aria-label="زيادة">+</button>' +
        '</div>' +
      '</div>' +
      '<button class="cart-item__remove" type="button" onclick="cartDrawerQty(' + keyArg + ',0)" aria-label="حذف ' + escHtml(item.product_title) + '">×</button>' +
    '</li>';
  }).join('');

  if (cartTotal) cartTotal.textContent = formatArabicMoney(cart.total_price);
  updateCartCount(cart.item_count);
}

window.cartDrawerQty = function (key, qty) {
  CartAPI.changeLine(key, qty).then(function (cart) {
    renderCartDrawer(cart);
    updateCartCount(cart.item_count);
  }).catch(function (err) { toast(err.message); });
};

function refreshCartDrawer() {
  CartAPI.get().then(renderCartDrawer);
}

/* ── Cart Drawer Open / Close ── */
function openCart() {
  if (!cartDrawer) return;
  cartDrawer.classList.add('open');
  cartDrawer.setAttribute('aria-hidden', 'false');
  if (overlay) overlay.classList.add('open');
  document.body.style.overflow = 'hidden';
  refreshCartDrawer();
  var closeBtn = document.getElementById('cartClose');
  if (closeBtn) closeBtn.focus();
}

function closeCart() {
  if (!cartDrawer) return;
  cartDrawer.classList.remove('open');
  cartDrawer.setAttribute('aria-hidden', 'true');
  if (!mobileMenu || !mobileMenu.classList.contains('open')) {
    if (overlay) overlay.classList.remove('open');
  }
  document.body.style.overflow = '';
}

if (cartBtn) cartBtn.addEventListener('click', openCart);
if (cartClose) cartClose.addEventListener('click', closeCart);
if (cartShopLink) cartShopLink.addEventListener('click', closeCart);

/* ── Mobile Menu ── */
function openMenu() {
  if (!mobileMenu) return;
  mobileMenu.classList.add('open');
  mobileMenu.setAttribute('aria-hidden', 'false');
  if (overlay) overlay.classList.add('open');
  if (hamburger) hamburger.classList.add('active');
  if (hamburger) hamburger.setAttribute('aria-expanded', 'true');
  document.body.style.overflow = 'hidden';
}

function closeMenu() {
  if (!mobileMenu) return;
  mobileMenu.classList.remove('open');
  mobileMenu.setAttribute('aria-hidden', 'true');
  if (!cartDrawer || !cartDrawer.classList.contains('open')) {
    if (overlay) overlay.classList.remove('open');
  }
  if (hamburger) hamburger.classList.remove('active');
  if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
  document.body.style.overflow = '';
}

if (hamburger) hamburger.addEventListener('click', openMenu);
if (mobileClose) mobileClose.addEventListener('click', closeMenu);
document.querySelectorAll('.mobile-menu__link').forEach(function (l) {
  l.addEventListener('click', closeMenu);
});

if (overlay) {
  overlay.addEventListener('click', function () { closeCart(); closeMenu(); });
}

document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') { closeCart(); closeMenu(); }
});

/* ── Add to Cart (product cards) ── */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.pcard__add');
  if (!btn) return;
  e.stopPropagation();

  var variantId = btn.dataset.variantId;
  if (!variantId) {
    toast('يرجى إعداد المنتجات في لوحة تحكم شوبيفاي');
    return;
  }

  btn.disabled = true;
  btn.textContent = '…';

  CartAPI.add(variantId, 1).then(function (item) {
    updateCartCount(BB.cartCount + 1);
    toast('تمت إضافة ' + item.product_title + ' إلى السلة');
    refreshCartDrawer();
    openCart();
  }).catch(function (err) {
    toast(err.message);
  }).finally(function () {
    btn.disabled = false;
    btn.textContent = 'أضف للسلة';
  });
});

/* ── Product Form (product page) ── */
var productForm = document.getElementById('productForm');
if (productForm) {
  productForm.addEventListener('submit', function (e) {
    e.preventDefault();

    var submitBtn = productForm.querySelector('.product-form__add');
    if (submitBtn && submitBtn.disabled) return;

    var variantIdInput = document.getElementById('productVariantId');
    var qtyInput       = document.getElementById('productQty');
    if (!variantIdInput || !variantIdInput.value) return;

    var submittingId  = variantIdInput.value;
    var submittingQty = parseInt(qtyInput ? qtyInput.value : 1) || 1;

    if (submitBtn) {
      submitBtn.disabled    = true;
      submitBtn.textContent = '…';
    }

    CartAPI.add(submittingId, submittingQty)
      .then(function (item) {
        updateCartCount(BB.cartCount + 1);
        toast('تمت إضافة ' + item.product_title + ' إلى السلة');
        refreshCartDrawer();
        openCart();
      })
      .catch(function (err) {
        toast(err.message);
      })
      .finally(function () {
        if (submitBtn) {
          var curId = parseInt(submittingId, 10);
          var curV  = variants.find(function (v) { return v.id === curId; });
          var avail = curV ? curV.available : true;
          submitBtn.disabled    = !avail;
          submitBtn.textContent = avail ? 'أضف إلى السلة' : 'نفذت الكمية';
        }
      });
  });

  var variants        = window.productVariants || [];
  var selectedOptions = [];

  /* One entry per option index: { isColor, el }. Read from the data
     attributes main-product.liquid already renders, so this never
     assumes color is option 1 or size is option 2 -- it mirrors
     whatever order Shopify actually returns for this product. */
  var optionMeta = [];
  productForm.querySelectorAll('.product-form__option').forEach(function (optEl) {
    var idx = parseInt(optEl.dataset.optionIndex, 10);
    optionMeta[idx] = { isColor: optEl.dataset.isColor === 'true', el: optEl };
  });

  function variantOptions(v) {
    return v.options || [v.option1, v.option2, v.option3].filter(Boolean);
  }

  function getSelectedOptions() {
    var opts = [];
    productForm.querySelectorAll('.product-form__option').forEach(function (optEl) {
      var idx    = parseInt(optEl.dataset.optionIndex, 10);
      var active = optEl.querySelector('.swatch.active, .size-btn.active');
      if (active) {
        opts[idx] = active.dataset.value;
      } else {
        var sel = optEl.querySelector('select');
        if (sel && sel.value) opts[idx] = sel.value;
      }
    });
    return opts;
  }

  function findMatchingVariant(opts) {
    return variants.find(function (v) {
      var vOpts = variantOptions(v);
      return opts.every(function (o, i) { return vOpts[i] === o; });
    });
  }

  /* True if some variant matches `val` at `idx` and matches every OTHER
     currently-selected option (idx itself is ignored, since that's the
     value being tested, not necessarily the one already picked there). */
  function isValueAvailable(idx, val, currentOpts) {
    return variants.some(function (v) {
      var vOpts = variantOptions(v);
      if (vOpts[idx] !== val) return false;
      if (!v.available) return false;
      return currentOpts.every(function (o, i) {
        return i === idx || o == null || vOpts[i] === o;
      });
    });
  }

  /* Disables (or re-enables) every swatch/size button whose value would
     no longer resolve to an available variant given the OTHER options
     currently selected. Reuses the existing .size-btn[disabled] /
     .swatch[disabled] styling -- nothing new to design. */
  function refreshAvailability() {
    var opts = getSelectedOptions();
    optionMeta.forEach(function (meta, idx) {
      if (!meta) return;
      meta.el.querySelectorAll('.swatch[data-option-index], .size-btn[data-option-index]').forEach(function (btn) {
        btn.disabled = !isValueAvailable(idx, btn.dataset.value, opts);
      });
    });
  }

  function clearOptionSelection(idx) {
    var meta = optionMeta[idx];
    if (!meta) return;
    meta.el.querySelectorAll('.swatch.active, .size-btn.active').forEach(function (b) {
      b.classList.remove('active');
      b.setAttribute('aria-pressed', 'false');
    });
    var label = productForm.querySelector('#option-value-' + idx);
    if (label) label.textContent = '';
  }

  /* Runs after every click. Never auto-selects a replacement value --
     if the option group that was just clicked makes another group's
     current choice impossible, that other choice is cleared instead of
     silently swapped to something else, so the customer explicitly
     re-picks it. */
  function handleOptionChange(changedIdx) {
    var opts = getSelectedOptions();
    optionMeta.forEach(function (meta, idx) {
      if (!meta || idx === changedIdx) return;
      var val = opts[idx];
      if (val == null) return;
      if (!isValueAvailable(idx, val, opts)) {
        clearOptionSelection(idx);
      }
    });

    refreshAvailability();
    evaluateSelection();
  }

  function evaluateSelection() {
    var opts     = getSelectedOptions();
    var complete = optionMeta.every(function (meta, idx) { return !meta || opts[idx] != null; });
    var msgEl    = document.getElementById('variantMessage');

    if (!complete) {
      var missingColor = false, missingOther = false;
      optionMeta.forEach(function (meta, idx) {
        if (!meta || opts[idx] != null) return;
        if (meta.isColor) { missingColor = true; } else { missingOther = true; }
      });

      var msg = 'يرجى اختيار اللون والمقاس';
      if (missingOther && !missingColor) msg = 'يرجى اختيار المقاس';
      else if (missingColor && !missingOther) msg = 'يرجى اختيار اللون';

      if (msgEl) { msgEl.textContent = msg; msgEl.hidden = false; }

      var addBtn = document.getElementById('productAddBtn');
      if (addBtn) addBtn.disabled = true;
      var buyBtn = document.getElementById('productBuyNow');
      if (buyBtn) buyBtn.disabled = true;
      return;
    }

    if (msgEl) { msgEl.hidden = true; msgEl.textContent = ''; }
    updateVariant();
  }

  function updateVariant() {
    var opts    = getSelectedOptions();
    var variant = findMatchingVariant(opts);
    if (!variant) return;

    var variantInput = document.getElementById('productVariantId');
    if (variantInput) variantInput.value = variant.id;

    var priceEl = document.getElementById('productPrice');
    if (priceEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceEl.innerHTML =
          '<s class="product-info__price-compare">' + formatArabicMoney(variant.compare_at_price) + '</s> ' +
          '<span class="product-info__price-current">' + formatArabicMoney(variant.price) + '</span>';
      } else {
        priceEl.innerHTML = '<span class="product-info__price-current">' + formatArabicMoney(variant.price) + '</span>';
      }
    }

    var addBtn = document.getElementById('productAddBtn');
    if (addBtn) {
      addBtn.disabled    = !variant.available;
      addBtn.textContent = variant.available ? 'أضف إلى السلة' : 'نفذت الكمية';
    }

    var buyBtn = document.getElementById('productBuyNow');
    if (buyBtn) buyBtn.disabled = !variant.available;

    updateStockMessage(variant);

    var g = document.getElementById('productGallery');
    if (g && variant.featured_image) {
      var target = g.querySelector('[data-image-id="' + variant.featured_image.id + '"]');
      if (target) {
        var slideIdx = parseInt(target.dataset.index, 10);
        g.querySelectorAll('.product-gallery__slide').forEach(function(s, i) {
          s.classList.toggle('active', i === slideIdx);
        });
        g.querySelectorAll('.product-gallery__thumb').forEach(function(t, i) {
          t.classList.toggle('active', i === slideIdx);
        });
        if (typeof currentSlideIdx !== 'undefined') currentSlideIdx = slideIdx;
      }
    }

    var titleEl = document.getElementById('productTitle');
    if (titleEl && window.productBaseTitle) {
      if (variant.title && variant.title !== 'Default Title') {
        titleEl.textContent = window.productBaseTitle + ' – ' + variant.title;
      } else {
        titleEl.textContent = window.productBaseTitle;
      }
    }

    if (history.replaceState) {
      history.replaceState({ variant: variant.id }, '', window.location.pathname + '?variant=' + variant.id);
    }
  }

  function updateStockMessage(variant) {
    var stockEl = document.getElementById('stockCounter');
    if (!stockEl) return;

    var inv     = window.bbVariantInventory && window.bbVariantInventory[String(variant.id)];
    var qty     = inv ? inv.qty     : (variant.inventory_quantity || 0);
    var managed = inv ? inv.managed : variant.inventory_management;
    var avail   = inv ? inv.avail   : variant.available;

    if (!avail) {
      stockEl.textContent = 'نفذت الكمية';
      stockEl.className   = 'product-info__stock product-info__stock--soldout';
    } else if (managed && qty > 0 && qty <= 10) {
      stockEl.textContent = 'متبقي ' + qty + ' قطع فقط';
      stockEl.className   = 'product-info__stock product-info__stock--low';
    } else {
      stockEl.textContent = '';
      stockEl.className   = 'product-info__stock';
    }
  }

  productForm.querySelectorAll('.swatch[data-option-index]').forEach(function (sw) {
    sw.addEventListener('click', function () {
      if (sw.disabled) return;
      var idx = sw.dataset.optionIndex;
      productForm.querySelectorAll('.swatch[data-option-index="' + idx + '"]').forEach(function (s) {
        s.classList.remove('active');
        s.setAttribute('aria-pressed', 'false');
      });
      sw.classList.add('active');
      sw.setAttribute('aria-pressed', 'true');
      var label = productForm.querySelector('#option-value-' + idx);
      if (label) label.textContent = sw.dataset.value;
      handleOptionChange(parseInt(idx, 10));
    });
  });

  productForm.querySelectorAll('.size-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      var idx = btn.dataset.optionIndex;
      productForm.querySelectorAll('.size-btn[data-option-index="' + idx + '"]').forEach(function (b) {
        b.classList.remove('active');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('active');
      btn.setAttribute('aria-pressed', 'true');
      var label = productForm.querySelector('#option-value-' + idx);
      if (label) label.textContent = btn.dataset.value;
      handleOptionChange(parseInt(idx, 10));
    });
  });

  productForm.querySelectorAll('select[data-option-index]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      handleOptionChange(parseInt(sel.dataset.optionIndex, 10));
    });
  });

  refreshAvailability();
}

/* ── Product Gallery ── */
var gallery = document.getElementById('productGallery');
if (gallery) {
  var slides = gallery.querySelectorAll('.product-gallery__slide');
  var thumbs = gallery.querySelectorAll('.product-gallery__thumb');
  var currentSlideIdx = 0;

  function setSlide(idx) {
    currentSlideIdx = idx;
    slides.forEach(function (s, i) {
      s.classList.toggle('active', i === idx);
    });
    thumbs.forEach(function (t, i) {
      t.classList.toggle('active', i === idx);
    });
  }

  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      setSlide(parseInt(t.dataset.index, 10));
    });
  });

  var prevBtn = document.getElementById('galleryPrev');
  var nextBtn = document.getElementById('galleryNext');
  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      setSlide((currentSlideIdx + 1) % slides.length);
    });
  }
  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      setSlide((currentSlideIdx - 1 + slides.length) % slides.length);
    });
  }

  var galleryMain = gallery.querySelector('.product-gallery__main');
  if (galleryMain && slides.length > 1) {
    var touchStartX = 0;
    galleryMain.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    galleryMain.addEventListener('touchend', function (e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        setSlide(diff < 0
          ? (currentSlideIdx + 1) % slides.length
          : (currentSlideIdx - 1 + slides.length) % slides.length);
      }
    }, { passive: true });
  }
}

/* ── Buy Now ── */
var buyNowBtn = document.getElementById('productBuyNow');
if (buyNowBtn && productForm) {
  var buyText = buyNowBtn.querySelector('.product-form__buy-text');
  var buyIcon = buyNowBtn.querySelector('.product-form__buy-icon');

  buyNowBtn.addEventListener('click', function () {
    var variantId = document.getElementById('productVariantId');
    var qtyInput  = document.getElementById('productQty');
    if (!variantId || !variantId.value) return;

    buyNowBtn.disabled = true;
    if (buyText) buyText.textContent = '…';
    if (buyIcon) buyIcon.style.display = 'none';

    CartAPI.add(variantId.value, parseInt(qtyInput ? qtyInput.value : 1) || 1)
      .then(function () {
        window.location.href = BB.routes.checkout || '/checkout';
      })
      .catch(function (err) {
        toast(err.message);
        buyNowBtn.disabled = false;
        if (buyText) buyText.textContent = 'اشترِ الآن';
        if (buyIcon) buyIcon.style.display = '';
      });
  });
}

/* ── Quantity Controls (product page) ── */
var qtyCtrl = document.querySelector('.product-form__qty-ctrl');
if (qtyCtrl) {
  qtyCtrl.addEventListener('click', function (e) {
    var btn = e.target.closest('.qty-btn');
    if (!btn) return;
    var inp = qtyCtrl.querySelector('.qty-input');
    var val = parseInt(inp.value, 10) || 1;
    if (btn.dataset.action === 'decrease') val = Math.max(1, val - 1);
    else val += 1;
    inp.value = val;
  });

  /* iOS Safari can keep a tapped button focused after release even with
     the CSS reset above. Blurring only these two buttons on touch clears
     that without affecting the quantity input or any other control. */
  var touchQuery = window.matchMedia('(hover: none), (pointer: coarse)');
  qtyCtrl.querySelectorAll('.qty-btn').forEach(function (qtyButton) {
    qtyButton.addEventListener('pointerup', function () {
      if (touchQuery.matches) {
        requestAnimationFrame(function () { qtyButton.blur(); });
      }
    });
  });
}

/* ── Cart Page: quantity + remove ──
   Uses the cart's stable line-item key (item.key, a string), never the
   line's numeric position — a position becomes stale the moment another
   line is removed or reordered, which is what caused
   /cart/change?line=N&quantity=0 to 404/error with "line parameter is
   invalid" for whichever line no longer sat at position N. */
(function () {
  var cartPageItems = document.querySelectorAll('.cart-page__item');
  if (!cartPageItems.length) return;

  var busy = false;
  function setBusy(state) {
    busy = state;
    document.querySelectorAll('.cart-qty-btn, .cart-page__item-remove').forEach(function (el) {
      el.disabled = state;
    });
  }

  function changeByKey(key, qty) {
    return fetch(BB.routes.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) {
          throw new Error(data.description || data.message || 'تعذر تحديث السلة، يرجى المحاولة مرة أخرى.');
        }
        return data;
      });
    });
  }

  document.querySelectorAll('.cart-qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (busy) return;
      var key = btn.dataset.lineKey;
      var inp = document.querySelector('.cart-qty-input[data-line-key="' + key + '"]');
      var val = parseInt(inp ? inp.value : 1, 10) || 1;
      if (btn.dataset.action === 'decrease') val = Math.max(0, val - 1);
      else val += 1;
      if (inp) inp.value = val;

      setBusy(true);
      changeByKey(key, val).then(function () {
        window.location.reload();
      }).catch(function (err) {
        setBusy(false);
        toast(err.message);
      });
    });
  });

  document.querySelectorAll('.cart-page__item-remove').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (busy) return;
      setBusy(true);
      changeByKey(btn.dataset.lineKey, 0).then(function () {
        window.location.reload();
      }).catch(function (err) {
        setBusy(false);
        toast(err.message);
      });
    });
  });
})();

/* ── Wishlist (localStorage) ── */
var WISHLIST_KEY = 'bb_wishlist';

function getWishlist() {
  try {
    var raw = JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
    return raw.map(function (item) {
      if (typeof item === 'string') return { id: item };
      return item;
    });
  } catch (e) { return []; }
}
function saveWishlist(list) {
  try {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
  } catch (e) {
    toast('تعذّر حفظ المفضلة على هذا الجهاز');
  }
}
function isInWishlist(pid) {
  var id = String(pid);
  return getWishlist().some(function (item) { return String(item.id) === id; });
}
function getProductDataFromBtn(btn) {
  var data = {
    id: String(btn.dataset.productId || ''),
    title: btn.dataset.productTitle || '',
    url: btn.dataset.productUrl || '',
    price: btn.dataset.productPrice || '',
    compare_price: btn.dataset.productComparePrice || '',
    image: btn.dataset.productImage || '',
    variant_id: btn.dataset.variantId || ''
  };
  return data;
}
function toggleWishlist(pid, data) {
  var id = String(pid);
  var wl = getWishlist();
  var inList = wl.some(function (item) { return String(item.id) === id; });
  if (inList) {
    wl = wl.filter(function (item) { return String(item.id) !== id; });
  } else {
    var entry = data || { id: id };
    entry.id = id;
    wl.push(entry);
  }
  saveWishlist(wl);
  syncWishlistUI(id, !inList);
  toast(!inList ? 'تمت الإضافة إلى المفضلة' : 'تمت الإزالة من المفضلة');
  return !inList;
}
function syncWishlistUI(pid, active) {
  var id = String(pid);
  document.querySelectorAll('.pcard__wish[data-product-id="' + id + '"]').forEach(function (btn) {
    btn.classList.toggle('active', active);
    btn.dataset.active = String(active);
  });
  document.querySelectorAll('.product-form__wishlist-btn[data-product-id="' + id + '"]').forEach(function (btn) {
    btn.classList.toggle('active', active);
    btn.dataset.active = String(active);
    var txt = btn.querySelector('.product-form__wishlist-text');
    if (txt) txt.textContent = active ? 'تمت الإضافة إلى المفضلة' : 'إضافة إلى المفضلة';
  });
}

function renderWishlist() {
  var grid = document.getElementById('wishlistGrid');
  var empty = document.getElementById('wishlistEmpty');
  var countEl = document.getElementById('wishlistCount');
  if (!grid) { return; }
  var wl = getWishlist().filter(function (item) { return item.title && item.url; });

  grid.innerHTML = '';

  if (!wl.length) {
    empty.style.display = '';
    grid.style.display = 'none';
    if (countEl) countEl.textContent = '';
    return;
  }

  empty.style.display = 'none';
  grid.style.display = '';
  if (countEl) {
    var countWord = wl.length === 1 ? 'منتج' : wl.length === 2 ? 'منتجان' : wl.length <= 10 ? 'منتجات' : 'منتج';
    countEl.textContent = wl.length + ' ' + countWord + ' في المفضلة';
  }

  wl.forEach(function (item) {
    var card = document.createElement('article');
    card.className = 'wcard';

    var priceHTML = '';
    if (item.compare_price) priceHTML += '<s>' + escHtml(displayStoredPrice(item.compare_price)) + '</s>';
    priceHTML += '<span>' + escHtml(displayStoredPrice(item.price)) + '</span>';

    var cartBtn = item.variant_id
      ? '<button type="button" class="wcard__cart" data-variant-id="' + escHtml(item.variant_id) + '">أضف إلى السلة</button>'
      : '<a href="' + escHtml(item.url) + '" class="wcard__cart">عرض المنتج</a>';

    card.innerHTML =
      '<button type="button" class="wcard__remove" data-id="' + escHtml(item.id) + '" aria-label="إزالة من المفضلة">' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6L6 18M6 6l12 12"/></svg>' +
      '</button>' +
      '<a href="' + escHtml(item.url) + '" class="wcard__img">' +
        (item.image ? '<img src="' + escHtml(item.image) + '" alt="' + escHtml(item.title) + '" loading="lazy" width="500" height="500">' : '') +
      '</a>' +
      '<div class="wcard__body">' +
        '<h3 class="wcard__name"><a href="' + escHtml(item.url) + '">' + escHtml(item.title) + '</a></h3>' +
        '<p class="wcard__price">' + priceHTML + '</p>' +
        cartBtn +
      '</div>';

    grid.appendChild(card);
  });

  grid.querySelectorAll('.wcard__remove').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.dataset.id;
      var wl = getWishlist().filter(function (item) { return String(item.id) !== String(id); });
      saveWishlist(wl);
      syncWishlistUI(id, false);
      renderWishlist();
    });
  });

  grid.querySelectorAll('.wcard__cart[data-variant-id]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var vid = btn.dataset.variantId;
      btn.disabled = true;
      var orig = btn.textContent;
      btn.textContent = 'جاري الإضافة...';
      CartAPI.add(vid, 1).then(function (item) {
        btn.textContent = 'تمت الإضافة ✓';
        btn.style.background = 'var(--green-dark)';
        updateCartCount(BB.cartCount + 1);
        refreshCartDrawer();
        setTimeout(function () {
          btn.textContent = orig;
          btn.style.background = '';
          btn.disabled = false;
        }, 2000);
      }).catch(function (err) {
        btn.textContent = orig;
        btn.disabled = false;
        toast(err.message);
      });
    });
  });
}

document.querySelectorAll('.pcard__wish').forEach(function (btn) {
  var pid = btn.dataset.productId;
  if (pid && isInWishlist(pid)) {
    btn.classList.add('active');
    btn.dataset.active = 'true';
  }
  btn.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (pid) toggleWishlist(pid, getProductDataFromBtn(btn));
  });
});

document.querySelectorAll('.product-form__wishlist-btn').forEach(function (btn) {
  var pid = btn.dataset.productId;
  if (pid) {
    if (isInWishlist(pid)) {
      btn.classList.add('active');
      btn.dataset.active = 'true';
      var txt = btn.querySelector('.product-form__wishlist-text');
      if (txt) txt.textContent = 'تمت الإضافة إلى المفضلة';
    }
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      toggleWishlist(pid, getProductDataFromBtn(btn));
    });
  }
});

renderWishlist();

/* ── Carousel (featured products) ── */
document.querySelectorAll('.carousel-arrow').forEach(function (btn) {
  btn.addEventListener('click', function () {
    var trackId = btn.dataset.track;
    var track = trackId ? document.getElementById(trackId) : null;
    if (!track) {
      track = btn.closest('.products-carousel');
      if (track) track = track.querySelector('.products-carousel__track');
    }
    if (!track) return;

    var card = track.querySelector('.pcard');
    var scrollAmount = card ? card.offsetWidth + 16 : 280;

    if (btn.classList.contains('carousel-arrow--prev')) {
      track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    } else {
      track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    }
  });
});

/* ── Sticky Header ── */
var headerEl = document.getElementById('header');
function handleHeaderScroll() {
  if (!headerEl) return;
  headerEl.classList.toggle('header--scrolled', window.scrollY > 40);
}
window.addEventListener('scroll', handleHeaderScroll, { passive: true });
handleHeaderScroll();

/* ── Scroll Reveal ── */
var revealObs = new IntersectionObserver(function (entries) {
  entries.forEach(function (entry) {
    if (entry.isIntersecting) {
      entry.target.classList.add('visible');
      revealObs.unobserve(entry.target);
    }
  });
}, { threshold: 0.1, rootMargin: '0px 0px -32px 0px' });

document.querySelectorAll('.reveal').forEach(function (el) {
  if (!el.closest('.hero')) revealObs.observe(el);
});

/* ── Hero Entrance ── */
window.addEventListener('load', function () {
  document.querySelectorAll('.hero .reveal').forEach(function (el, i) {
    setTimeout(function () { el.classList.add('visible'); }, 180 + i * 110);
  });
});

/* ── Newsletter Form ── */
var newsletterForm = document.getElementById('newsletterForm');
if (newsletterForm) {
  newsletterForm.addEventListener('submit', function (e) {
    var inp = newsletterForm.querySelector('.newsletter__input');
    if (!inp || !inp.value.trim()) { e.preventDefault(); return; }
  });
}

/* ── Init ── */
refreshCartDrawer();
